/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const BatteryQuarter = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M17 7v2h1v2h-1v2H2V7h15zm.5-2h-16C.7 5 0 5.7 0 6.5v7c0 .8.7 1.5 1.5 1.5h16c.8 0 1.5-.7 1.5-1.5V13h.2c.4 0 .8-.3.8-.8V7.8c0-.5-.3-.8-.8-.8H19v-.5c0-.8-.7-1.5-1.5-1.5zM7 8H3v4h4V8z" />
  </svg>
);

export default extendIcon(BatteryQuarter);
